import moment from 'moment';

if (typeof window.moment === 'undefined') {
  window.moment = moment;
}
